import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'semantic-ui-react';
import StudentListStudentName from '../studentList/StudentListStudentName';
import StudentListSuccessScore from '../studentList/StudentListSuccessScore';
import { InterventionListIntervention } from 'utils/types';
import { getTenantConfig } from 'utils/tenant';
import Checkbox from '../SF/Checkbox';
import InterventionName from './InterventionName';

export default class InterventionListTableRow extends React.Component {

  get interventionSelector() {
    return <Checkbox ariaLabel={`Select ${this.props.intervention.name} for ${this.props.intervention.studentName}`}
                     checked={this.props.interventionIsSelected}
                     value={this.props.intervention.interventionId}
                     onChange={this.props.selectIntervention} />
  }

  get studentName() {
    return <StudentListStudentName getStudentFolderLink={this.props.getStudentFolderLink}
                                   hasPhoto={this.props.intervention.hasPhoto}
                                   id={this.props.intervention.studentId}
                                   name={this.props.intervention.studentName}
                                   studentId={this.props.intervention.studentExtId}
                                   studentType="student"
                                   uuid={this.props.intervention.studentUuid}/>
  }

  get successScore() {
      if (!getTenantConfig('SUCCESS_SCORE_ENABLED')) return null;
      return <Table.Cell>
          <StudentListSuccessScore getSuccessScoreRange={this.props.getSuccessScoreRange}
                                   studentId={this.props.intervention.studentId}
                                   successScore={this.props.intervention.successScore} />
      </Table.Cell>
  }

  get interventionName() {
    return <InterventionName interventionId={this.props.intervention.interventionId}
                             interventionName={this.props.intervention.name}
                             interventionTrigger={this.props.intervention.trigger}
                             interventionType={this.props.intervention.type}
                             studentId={this.props.intervention.studentId} />
  }

  get assignmentInfo() {
    if (!getTenantConfig('ASSIGN_TRACKING_ITEM_ENABLED')) return null;
    return <Table.Cell className="intervention-assignment">{this.props.intervention.assignedInfo}</Table.Cell>;
  }

  render() {
    return (
      <Table.Row>
        <Table.Cell>{this.interventionSelector}</Table.Cell>
        <Table.Cell scope="row">{this.studentName}</Table.Cell>
        {this.successScore}
        <Table.Cell className="wrap">{this.interventionName}</Table.Cell>
        <Table.Cell className="intervention-status">{this.props.intervention.status}</Table.Cell>
        <Table.Cell className="intervention-raised">{this.props.intervention.raisedInfo}</Table.Cell>
        <Table.Cell className="intervention-cleared">{this.props.intervention.clearedInfo}</Table.Cell>
        {this.assignmentInfo}
        <Table.Cell className="intervention-due">{this.props.intervention.dueDate}</Table.Cell>
      </Table.Row>
    )
  }

}

InterventionListTableRow.propTypes = {
  getStudentFolderLink: PropTypes.func.isRequired,
  getSuccessScoreRange: PropTypes.func.isRequired,
  intervention: InterventionListIntervention.isRequired,
  interventionIsSelected: PropTypes.bool.isRequired,
  selectIntervention: PropTypes.func.isRequired
};
